<ng-container *ngIf="showForm" [formGroup]="playInfoForm">
  <input type="hidden" formControlName="id" />

  <ng-select
    *ngIf="!selectClips && searchEvents && !uploadClip"
    [items]="eventsList$ | async"
    bindLabel="name"
    bindValue="id"
    formControlName="eventId"
    placeholder="Select Event *"
    [minTermLength]="3"
    typeToSearchText="Please enter 3 or more characters"
    [loading]="eventLoading"
    [typeahead]="eventInput$"
    (change)="changeEvent($event)"
    notFoundText="No events found"
    appendTo="body"
    class="normal-white"
  >
    <ng-template ng-loadingspinner-tmp>
      <div class="loader mr-5">
        <div class="ball1"></div>
        <div class="ball2"></div>
        <div class="ball3"></div>
      </div>
    </ng-template>
  </ng-select>

  <ng-select
    *ngIf="!selectClips && !searchEvents && !uploadClip"
    [items]="dropdownEvents"
    bindLabel="name"
    bindValue="value"
    placeholder="Select an event *"
    [class.input-error]="formHelpersService.isInputInvalid(playInfoForm, 'eventId')"
    formControlName="eventId"
    (change)="changeEvent($event)"
    [clearable]="false"
    [searchable]="false"
    appendTo="body"
    class="normal-white"
  >
  </ng-select>

  <ng-select
    *ngIf="!selectClips && !uploadClip"
    [items]="dropdownGames"
    bindLabel="name"
    bindValue="value"
    placeholder="Select a game *"
    [class.input-error]="formHelpersService.isInputInvalid(playInfoForm, 'gameId')"
    formControlName="gameId"
    (change)="changeGame($event)"
    [clearable]="false"
    [searchable]="false"
    [readonly]="!dropdownGames.length"
    [loading]="gamesLoading"
    [virtualScroll]="true"
    appendTo="body"
    class="normal-white games-dropdown"
  >
    <ng-template ng-option-tmp let-item="item" let-index="index">
      <div class="game-opt-container">
        <span>{{ item.name }}</span>
        <span class="time" *ngIf="item.showTime">
          {{ item.date | date: 'h:mm a' }}
        </span>
      </div>
    </ng-template>
    <ng-template ng-loadingspinner-tmp>
      <div class="loader mr-5">
        <div class="ball1"></div>
        <div class="ball2"></div>
        <div class="ball3"></div>
      </div>
    </ng-template>
  </ng-select>

  <ng-select
    *ngIf="selectClips || (!selectClips && uploadClip)"
    [items]="addClipOptions"
    bindLabel="name"
    bindValue="value"
    (change)="onClipOptionChange($event)"
    formControlName="clipOption"
    [clearable]="false"
    [searchable]="false"
    class="no-transparency"
    class="normal-white"
  >
  </ng-select>

  <ng-select
    *ngIf="selectClips && !uploadClip && formHelpersService.hasField(playInfoForm, 'clipId')"
    [items]="userClips"
    bindLabel="name"
    bindValue="value"
    placeholder="Select a clip *"
    [class.input-error]="formHelpersService.isInputInvalid(playInfoForm, 'clipId')"
    formControlName="clipId"
    (change)="onClipChangedDropdown($event)"
    [clearable]="false"
    [searchable]="false"
    class="normal-white"
    appendTo="body"
  >
  </ng-select>

  <div
    class="input input-text"
    *ngIf="uploadClip && formHelpersService.hasField(playInfoForm, 'title')"
    [class.input-error]="formHelpersService.isInputInvalid(playInfoForm, 'title')"
  >
    <input
      name="title"
      id="title"
      type="text"
      placeholder="Add a title for your clip *"
      autocomplete="off"
      formControlName="title"
      [readonly]="readonly"
      #titleInput
    />
  </div>

  <div
    class="input input-text"
    *ngIf="uploadClip && formHelpersService.hasField(playInfoForm, 'hrDate')"
    [class.input-error]="formHelpersService.isInputInvalid(playInfoForm, 'hrDate')"
  >
    <input
      appDateFormat
      name="hrDate"
      id="hrDate"
      type="text"
      placeholder="Date: MM/DD/YY *"
      autocomplete="off"
      formControlName="hrDate"
      [readonly]="readonly"
      #hrDateInput
    />
  </div>

  <div
    class="input input-text"
    *ngIf="formHelpersService.hasField(playInfoForm, 'jerseyNumber')"
    [class.input-error]="formHelpersService.isInputInvalid(playInfoForm, 'jerseyNumber')"
  >
    <input
      name="jerseyNumber"
      id="jerseyNumber"
      type="text"
      placeholder="Jersey # *"
      autocomplete="off"
      formControlName="jerseyNumber"
      [readonly]="readonly"
      #jerseyNumberInput
    />
  </div>

  <div
    class="input input-text"
    *ngIf="!selectClips && !uploadClip && formHelpersService.hasField(playInfoForm, 'timecode')"
    [class.input-error]="formHelpersService.isInputInvalid(playInfoForm, 'timecode')"
  >
    <input
      name="timecode"
      id="timecode"
      type="text"
      placeholder="Timecode of play (ex: 1:00-1:30) *"
      autocomplete="off"
      formControlName="timecode"
      [readonly]="readonly"
      #timecodeInput
    />
  </div>

  <div
    class="input input-textarea"
    *ngIf="formHelpersService.hasField(playInfoForm, 'description')"
    [class.input-error]="formHelpersService.isInputInvalid(playInfoForm, 'description')"
  >
    <textarea
      name="description"
      id="description"
      placeholder="Description of play (optional)"
      formControlName="description"
      [readOnly]="readonly"
    ></textarea>
  </div>
</ng-container>
